export default "__VITE_ASSET__BMpw9$0I__"